const X = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.8874 0.19502C1.8874 0.19502 1.9437 0.0975103 1.97185 0.0487552C2 1.85259e-07 2.09809 0.0566298 2.14713 0.0849446L9.10133 5.59511C9.24846 5.68006 9.24121 5.80588 9.283 5.96002C9.27574 6.08585 9.26849 6.21167 9.23308 6.38625C9.23308 6.38625 9.17679 6.48376 9.09959 6.5042C9.05055 6.47589 8.97336 6.49633 8.95247 6.41926L1.99826 0.90909C1.90017 0.85246 1.85839 0.69832 1.86564 0.572495C1.8729 0.44667 1.88015 0.320845 1.8874 0.19502Z"
        fill="currentColor"
      />
      <path
        d="M9.1126 0.19502C9.1126 0.19502 9.0563 0.0975103 9.02815 0.0487552C9 1.85259e-07 8.90191 0.0566298 8.85287 0.0849446L1.89867 5.59511C1.75154 5.68006 1.75879 5.80588 1.717 5.96002C1.72426 6.08585 1.73151 6.21167 1.76692 6.38625C1.76692 6.38625 1.82321 6.48376 1.90041 6.5042C1.94945 6.47589 2.02664 6.49633 2.04753 6.41926L9.00174 0.90909C9.09983 0.85246 9.14161 0.69832 9.13436 0.572495C9.1271 0.44667 9.11985 0.320845 9.1126 0.19502Z"
        fill="currentColor"
      />
    </svg>
  )
}

X.displayName = 'X'

export default X
